import React, { useContext } from 'react';
import CommonBox from './components/CommonBox';
import GifImagesSection from './components/GifImagesSection';
import ResultSection from './components/ResultSection';
import LoginContext from './context';
import NewResult from './components/NewResult';

const Result = () => {
  const { isAuthenticated } = useContext(LoginContext);
  const { token } = useContext(LoginContext);

  console.log(token);
  return (
    <>
      <section className="result-section">
        {/* <CommonBox heading=" 경기결과 " englishHeading=" result" isEnglishHeadingOnMobile={true} isAuthenticated={isAuthenticated}>
                    <ResultSection />
                </CommonBox> */}
        <NewResult />
      </section>
      <section className="gif-section flex lg:hidden items-center justify-center">
        <GifImagesSection />
      </section>
    </>
  );
};

export default Result;
